export default __webpack_public_path__ + "15a87f9e36effd433d30dc9bda499627.png";